import Template from "../Template";

export default function Gallery (){
    return (
        <>
        <Template />
        </>
        )
}